document.addEventListener("DOMContentLoaded", function () {
  const box = document.getElementById("portal-timer-box");
  const heading = document.getElementById("portal-timer-heading");

  if (!box || !heading) return;

  const open  = new Date(box.dataset.open).getTime();
  const close = new Date(box.dataset.close).getTime();

  // Track which phase we were in on the previous tick
  // so we can detect the moment we cross from "closed" -> "open"
  let lastPhase = (function () {
    const now = Date.now();
    if (now < open) return "before";          // portal not open yet
    if (now >= open && now <= close) return "open";
    return "after";                           // portal already closed
  })();

  function update() {
    const now = Date.now();
    let phase;

    if (now < open) {
      phase = "before";
      heading.innerText = "Build Your Own Putter portal opens in:";
      box.innerText = format(open - now);
      document.body.classList.remove("byop-portal-open");
    } else if (now >= open && now <= close) {
      phase = "open";
      heading.innerText = "Portal closes in:";
      box.innerText = format(close - now);
      document.body.classList.add("byop-portal-open");
    } else {
      phase = "after";
      heading.innerText = "Portal is now closed";
      box.innerText = "";
      document.body.classList.remove("byop-portal-open");
    }

    // If we JUST went from "before" -> "open", reload once so
    // Zepto can rebuild and position the Personalize button correctly
    if (lastPhase === "before" && phase === "open") {
      window.location.reload();
      return; // stop this tick; page is reloading
    }

    lastPhase = phase;
  }

  function format(ms) {
    const d = Math.floor(ms / (1000 * 60 * 60 * 24));
    const h = Math.floor((ms / (1000 * 60 * 60)) % 24);
    const m = Math.floor((ms / (1000 * 60)) % 60);
    const s = Math.floor((ms / 1000) % 60);
    return `${d}d ${h}h ${m}m ${s}s`;
  }

  update();
  setInterval(update, 1000);
});